module.exports = {"TXTWCL_Place_Bet":{"id":"TXTWCL_Place_Bet","defaultMessage":"Spil","track":"Place Bet"}}